<!-- 翠麟精英 -->
<template>
  <div class="Talent bg-round bg-fff">
    <div class="container" id="w-1200px">
      <Bread :list="breadList" class="ma-t-10" />
      <div class="b-b-1-eee flex f-jcenter width100 overflow-auto">
        <div class="pa-30 c-p white-s-n"  :class="{'tab-active':categoryId==0}" @click="categoryId=0;loadDataList()">全部</div>
        <div class="pa-30 c-p white-s-n" v-for="(item, index) in categoryList" :key="index" :class="{'tab-active':categoryId==item.Id}" @click="categoryId=item.Id;loadDataList()">
          {{ item.Name }}
        </div>
      </div>

      <div class="ma-t-30 flex f-wrap">
        <div
          class="talent-item ma-b-30"
          v-for="(item1, index1) in dataList" @click="$router.push({path:'/talent/detail',query:{id:item1.Id}})"
          :key="index1"
        >
          <div class="photo-frame">
            <img :src="item1.Image" alt="" width="100%" height="100%" class="img_cover" v-if="item1.Image!=''" />
            <img src="../img/logo_i.png" alt="" width="100%" height="100%" class="img_cover" v-else />
            <div class="box-name flex f-center f-jcenter">
              <div class="t-omit-1 c-fff">{{ item1.Name }}</div>
            </div>
          </div>
          <div class="flex f-end ma-t-20">
            <div
              v-for="(item, index) in item1.CategoryList"
              :key="index"
              class="pa-lr-10 pa-tb-5 b-r-10 bg-fb004d c-fff ma-l-10"
            >
              {{ item }}
            </div>
          </div>
          <div class="c-red pa-b-10 t-right">________</div>
         
        </div>
      </div>
      <Empty :isShow="!dataList.length"></Empty>
      <div class="fy t-center">
        <el-pagination
          @current-change="handleCurrentChange"
          :hide-on-single-page="true"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="totals"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Bread from "../components/Bread.vue";
import { getTalentList,getTalentCategory } from "../api.js";
export default {
  components: {
    Bread,
  },
  data() {
    return {
      breadList: [
        {
          name: "翠麟精英",
          path: "/talent/index",
        },
      ],
      categoryList: [],
      activeName: "first",
      totals: 0, //一个分类下的总条数
      pageIndex: 1,
      pageSize:16,
      categoryId:0,
      dataList:[]
    };
  },
  created(){
    this.loadData()
    this.loadDataList();

  },
  methods: {
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.loadDataList();
    },
    loadData(){
      getTalentCategory().then(res=>{
        this.categoryList=res.data.Data
      })
    },
    //获取列表数据
    loadDataList(){
      getTalentList({
        pageIndex:this.pageIndex,
        pageSize:this.pageSize,
        categoryid:this.categoryId
      }).then(res=>{
        this.dataList=res.data.Data.List
        this.totals=res.data.Data.TotalCount
      })
    }
  },
};
</script>

<style scoped lang="scss">
.Talent .container{
    // min-height: 1150px;
    // background: #ffffff;
    box-sizing: border-box;
    padding: 30px 40px;
}
.tab-active {
  border-bottom: 3px solid #fb004d;
  color: #fb004d;
  font-weight: bold;
}
.pa-tb-5 {
  padding-top: 5px;
  padding-bottom: 5px;
}
.talent-item {
  width: 20%;
}
.talent-item:not(:nth-child(4n)) {
  margin-right: calc(20%/3);
}
.photo-frame {
  border: 4px solid #fb004d;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  // width: 210px;
  height: 260px;
  .box-name {
    border-top-left-radius: 40px;
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100px;
    height: 40px;
    background: #fb004d;
  }
}
</style>